// extracted by mini-css-extract-plugin
module.exports = {"root":"Blog_root__1-Fi5","posts":"Blog_posts__Bk-iH","post":"Blog_post__1sn8l","circleBg":"Blog_circleBg__3KY8c","spinner":"Blog_spinner__3xGVx"};